export default __webpack_public_path__ + "static/media/keto_urination@2x.acc9c2c0.jpg";